"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CourseDetailsLayout = exports.CourseDetailsLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var main_aside_1 = require("../../components/elements/main-aside");
var content_section_1 = require("../../components/elements/content-section");
var entity_link_value_1 = require("../../components/entities/entity-link-value");
var content_node_1 = require("../../components/entities/content-node");
var entity_value_1 = require("../../components/entities/entity-value");
var grid_1 = require("../../components/elements/grid");
var entity_link_1 = require("../../components/entities/entity-link");
var entity_grid_1 = require("../../components/entities/entity-grid");
var lodash_1 = require("lodash");
var entity_list_1 = require("../entities/entity-list");
var entity_list_section_1 = require("../entities/entity-list-section");
var file_asset_value_1 = require("../entities/file-asset-value");
var link_value_1 = require("../entities/link-value");
var use_entities_1 = require("../../hooks/use-entities");
var ui_1 = require("@shapeable/ui");
var cls = (0, utils_1.classNames)('program-details-layout');
exports.CourseDetailsLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var MainAsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ContentNodeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " 0 ", ";\n\n    &:first-child {\n      padding-top: 0;\n    }\n  "], ["\n    padding: ", " 0 ", ";\n\n    &:first-child {\n      padding-top: 0;\n    }\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(4))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n    margin-top: ", ";\n  "], ["\n    ", ";\n    margin-top: ", ";\n  "])), ContentNodeStyles, theme_1.theme.UNIT(4))
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var EntityLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var CardGridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ModuleCardGridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    a {\n      display: block;\n      box-sizing: border-box;\n    }\n  "], ["\n    a {\n      display: block;\n      box-sizing: border-box;\n    }\n  "])))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ListSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  MainAside: (0, styled_components_1.default)(main_aside_1.MainAside)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), MainAsideStyles),
  Main: styled_components_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  Section: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  Description: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  LinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  ListSection: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ListSectionStyles),
  List: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ListStyles),
  EntityLink: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), EntityLinkStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  ModuleCardGrid: (0, styled_components_1.default)(entity_grid_1.EntityGrid)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), ModuleCardGridStyles),
  CardGrid: (0, styled_components_1.default)(entity_grid_1.EntityGrid)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), CardGridStyles),
  // CourseCard: styled(CourseCard)`${EntityLinkStyles}`,
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), GridStyles)
};
var CourseDetailsLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    banner = props.banner,
    asideHeader = props.asideHeader,
    asideFooter = props.asideFooter,
    mainHeader = props.mainHeader,
    mainFooter = props.mainFooter;
  var entities = (0, use_entities_1.useEntities)();
  var t = (0, ui_1.useLang)();
  var programDefn = entities.Program;
  var _a = entity || {},
    description = _a.description,
    _b = _a.participants,
    participants = _b === void 0 ? [] : _b,
    _c = _a.videos,
    videos = _c === void 0 ? [] : _c,
    _d = _a.links,
    links = _d === void 0 ? [] : _d,
    _e = _a.lessons,
    lessons = _e === void 0 ? [] : _e,
    _f = _a.providers,
    providers = _f === void 0 ? [] : _f,
    _g = _a.presenters,
    presenters = _g === void 0 ? [] : _g,
    _h = _a.fileAssets,
    fileAssets = _h === void 0 ? [] : _h,
    _j = _a.programs,
    programs = _j === void 0 ? [] : _j;
  var hasProviders = !!providers.length;
  var hasLessons = !!lessons.length;
  var hasPresenters = !!presenters.length;
  var hasParticipants = !!participants.length;
  var hasFileAssets = !!fileAssets.length;
  var hasLinks = !!links.length;
  var hasVideos = !!videos.length;
  var hasAside = asideHeader || asideFooter;
  var hasPrograms = !!programs.length && !!programDefn;
  var programsLabel = programDefn === null || programDefn === void 0 ? void 0 : programDefn.countLabel({
    count: programs.length,
    t: t
  });
  ;
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, banner, react_1.default.createElement(My.MainAside, {
    main: react_1.default.createElement(My.Main, null, mainHeader, hasProviders && react_1.default.createElement(My.Section, {
      title: 'Provider:'
    }, react_1.default.createElement(My.Grid, {
      spacing: 0,
      columns: 2,
      items: providers.map(function (provider) {
        var _a;
        return react_1.default.createElement(My.EntityLink, {
          key: provider.id,
          entity: provider
        }, react_1.default.createElement(My.Value, {
          entity: provider,
          label: (_a = provider === null || provider === void 0 ? void 0 : provider.location) === null || _a === void 0 ? void 0 : _a.name,
          name: provider.name
        }));
      })
    })), hasPrograms && react_1.default.createElement(My.Section, {
      title: "Part of:"
    }, react_1.default.createElement(My.Grid, {
      spacing: 0,
      columns: 2,
      items: programs.map(function (program) {
        return react_1.default.createElement(My.LinkValue, {
          key: program.id,
          entity: program
        });
      })
    })), react_1.default.createElement(My.Section, null, react_1.default.createElement(My.Description, {
      entity: description,
      title: 'Synopsis:'
    })), hasLessons && react_1.default.createElement(My.Section, {
      title: 'Modules:'
    }, react_1.default.createElement(My.ModuleCardGrid, {
      entityTypeName: 'Lesson',
      items: lessons
    })), hasPresenters && react_1.default.createElement(My.Section, {
      title: "".concat((0, lodash_1.trim)(process.env.COURSE_PRESENTERS_LABEL || 'Presenters', ":"), ":")
    }, react_1.default.createElement(My.Grid, {
      spacing: 0,
      columns: 2,
      items: presenters.map(function (presenter) {
        return react_1.default.createElement(My.EntityLink, {
          key: presenter.id,
          entity: presenter
        }, react_1.default.createElement(My.Value, {
          entity: presenter,
          label: presenter === null || presenter === void 0 ? void 0 : presenter.position,
          name: presenter.name
        }));
      })
    })), hasParticipants && react_1.default.createElement(My.Section, {
      title: 'Participants:'
    }, react_1.default.createElement(My.Grid, {
      spacing: 0,
      columns: 2,
      items: participants.map(function (person) {
        return react_1.default.createElement(My.EntityLink, {
          key: person.id,
          entity: person
        }, react_1.default.createElement(My.Value, {
          entity: person,
          label: person === null || person === void 0 ? void 0 : person.position,
          name: person.name
        }));
      })
    })), hasFileAssets && react_1.default.createElement(My.ListSection, {
      variant: 'large',
      rowComponent: file_asset_value_1.FileAssetValue,
      showDividers: true,
      title: "Related Files:",
      items: fileAssets,
      maxItems: 3
    }), hasVideos && react_1.default.createElement(My.Section, {
      title: "Videos:"
    }, react_1.default.createElement(My.List, {
      showDescription: true,
      items: videos
    })), hasLinks && react_1.default.createElement(My.ListSection, {
      useLinks: false,
      title: "Related Links:",
      maxItems: 4,
      items: links,
      rowComponent: link_value_1.LinkValue
    })),
    aside: hasAside && react_1.default.createElement(My.Aside, null, asideHeader, asideFooter)
  }));
};
exports.CourseDetailsLayout = CourseDetailsLayout;
exports.CourseDetailsLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29;